import React, { Fragment } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import { Grid } from "@material-ui/core";

const LabelGridItem = styled(Grid)`
  && {
    font-size:17px;
    margin-top:12px;
    width:100%;
  }
`;
const ScrollWrapper = styled(FormGroup)`
  && {
    max-height:260px;
    overflow-y:auto;
    color: red
  }

`;

const WideFormControlLabel = styled(FormControlLabel)`
&&{
  min-width: 300px;
}
`;

const styles = theme => ({
  root: {
    margin: "0",
    display: "flex"
  },
  formControl: {},
  alertText: {
    color: "red"
  },
  nameLabel: {
    width: 300
  }
});

const CheckboxElement = ({ contact, isChecked, handleAlertContactsChange, colWidth, classes }) => (
  <Grid
    container
    className={classes.nameLabel}
    key={`g-${contact.id}`}
    item
    xs={colWidth}
    md={colWidth}
    lg={colWidth}
  >
    <WideFormControlLabel
      key={`fcl-${contact.id}`}
      label={`${contact.firstName ? contact.firstName : ""} ${contact.lastName ? contact.lastName : ""}`}
      control={
        <Checkbox
          key={`cb-${contact.id}`}
          checked={isChecked(contact)}
          onChange={handleAlertContactsChange(contact)}
          value={contact.id.toString()}
        />
      }
    />
  </Grid>
);

class ContactsSelection extends React.Component {
  render() {
    const { classes, notificationId, checkIds, isChecked, handleAlertContactsChange, companyContacts } = this.props;
    const error = !checkIds();

    return (
      <Grid container>
        <LabelGridItem item xs={1} container>
          To
        </LabelGridItem>
        <Grid item xs={11}>
          <FormControl component="fieldset" className={classes.formControl}>
            <ScrollWrapper>
              <Grid container justify="space-between">
                {companyContacts && companyContacts.map(contact => (
                  <CheckboxElement
                    key={contact.id}
                    contact={contact}
                    isChecked={isChecked}
                    colWidth={6}
                    handleAlertContactsChange={handleAlertContactsChange}
                    classes={classes}
                  />
                ))}
              </Grid>
            </ScrollWrapper>
            {error && (
              <>
                <FormHelperText className={classes.alertText}>ADMIN ACTION REQUIRED:</FormHelperText>
                <FormHelperText className={classes.alertText}>There are contacts receiving this notification that are not associated with your company.</FormHelperText>
                <FormHelperText className={classes.alertText}>
                  Ref ID:
                  {notificationId}
                </FormHelperText>
              </>)}
          </FormControl>
        </Grid>
      </Grid>
    );
  }
}

ContactsSelection.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ContactsSelection);
